import api from '../../utils/api'

export const state = {}

export const mutations = {}


export const actions = {
  async handleUpdateOpen(_, body) {
    try {
      const { _id } = body || {}
      return await api.put(`product/${_id}/open`, body)
    } catch (e) {
      console.error(e)
    }
  }
}

export const getters = {}
